import React,{ useState, useEffect,useRef }  from 'react'
import { Form, Input, Button,Row,Col,message,Tabs, Space} from 'antd'
import { MobileOutlined ,KeyOutlined} from '@ant-design/icons'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setFirmLogin } from '../store/firmLoginSlice'
import { useLoginCodeMutation,   useYonghuLoginMutation } from '../store/ReactWebSiteApi'
import WebMain from '../front/WebMain'
function FirmLogin() {
    //获取已登录用户数据
    const prevUserPhone = JSON.parse(localStorage.getItem('eu_ba_phone'));
    //绑定手机号
    const [adminPhone, setAdminPhone] = useState(prevUserPhone);
    const adminPhoneInput = (e) => {
        setAdminPhone(prevState => e.target.value);
    }
    //绑定验证码
    const [adminCode, setAdminCode] = useState();
    const adminCodeInput = (e) => {
        setAdminCode(prevState => e.target.value);
    }
    //验证码倒计时
    const [isNote, setIsNote] = useState(false);
    const [time, setTime] = useState(null);
    const timeRef = useRef();
    useEffect(() => {
        if (time && time !== 0) {
            timeRef.current = setTimeout(() => {
                setTime((time) => time - 1);
            }, 1000);
        } else {
            setIsNote(false);
        }
        return () => {
            clearInterval(timeRef.current);
        };
    }, [time]);
  
    //获取验证码数据
    const [getCode] = useLoginCodeMutation();
    //获取验证码
    const getCodeBtn = () => {
        setTime(60);
        setIsNote(true);
        getCode({
            phone:adminPhone,
        }).then((res) => {
            console.log(res);
            if(res.data.Status==='success'){
                setTime(60);
                setIsNote(true);
            }
            if (res.data.Status === 'fail') {
                message.error('该手机号码未注册！'+ res.data.Message)    
            }
        })    
    }
    //数据上传
    const [login] = useYonghuLoginMutation();    
    //分发
    const dispatch = useDispatch();
    //跳转
    const navi = useNavigate();
    const location = useLocation();
    const prelocation = location.state?.prelocation?.pathname || location.state?.from?.pathname
    const returnPath = prelocation && prelocation !== '/FirmLogin' ? prelocation : '/'
    //短信验证码登录，提交表单
    const onFinish = (values) => {
        //  console.log('Success:', values);
        login({
            'byxkh_yh_phone': adminPhone,
            'byxkh_yh_password':adminCode
        }).then(res => {
            console.log(res);     
            if (res.data.Status === "success") {                  
                const loginUser = Array.isArray(res.data.Result) ? res.data.Result[0] : res.data.Result
                if (!loginUser) {
                    message.error('登录结果为空')
                    return
                }
                dispatch(setFirmLogin(loginUser))
                navi(returnPath, { replace: true })
                
            } else if (res.data.Status === 'fail') {
                message.error(res.data.Message);             
            }
        })        
    };
    //提交表单（失败）  
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    
    
    //密码登录
    const [passwordLoginInfo,setPasswordLoginInfo] = useState({ba_phone:prevUserPhone})
    const [passwordLoginSubmit] = useYonghuLoginMutation()
    const passwordLogin = <div>
                            <Form
                                name="mmlogin"
                                className="login-form"
                                initialValues={{remember: true,}}
                                onFinish={() => {
                                    passwordLoginSubmit({
                                        byxkh_yh_phone:passwordLoginInfo.ba_phone,
                                        byxkh_yh_password:passwordLoginInfo.ba_pwd,
                                    }).then(res => {
                                        if (res.data.Status === "success") {                                                    
                                            const loginUser = Array.isArray(res.data.Result) ? res.data.Result[0] : res.data.Result
                                            if (!loginUser) {
                                                message.error('登录结果为空')
                                                return
                                            }
                                            dispatch(setFirmLogin(loginUser))
                                            navi(returnPath, { replace: true }); 
                                            
                                        } else if (res.data.Status === 'fail') {
                                            message.error(res.data.Message);             
                                        }
                                    })        
                                }}   
                            >
                                <Form.Item
                                    name="userPhone"
                                    validateTrigger="onBlur"
                                    rules={[{
                                        required: true,
                                        message: '请填写手机号!',
                                    },
                                    {
                                    pattern: /^1[3-9]\d{9}$/,
                                    message: '请输入正确的手机号'
                                        }]}
                                    initialValue={prevUserPhone}
                                    
                                >
                                    <Input 
                                        prefix={<MobileOutlined className="site-form-item-icon" />} 
                                        placeholder="请输入手机号" 
                                        value={passwordLoginInfo.ba_phone} 
                                        onChange={(e) => {setPasswordLoginInfo(prevState=>({...prevState,ba_phone:e.target.value}))}} 
                                        size="large"
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="mm"
                                    validateTrigger="onBlur"    
                                    rules={[
                                        {
                                            required: true,
                                            message: '请填写登录密码!',
                                        }]}
                                    >
                                        <Input 
                                            size="large" 
                                            placeholder='请输入登录密码' 
                                            prefix={<KeyOutlined className="site-form-item-icon" />} 
                                            value={passwordLoginInfo.ba_pwd} 
                                            onChange={(e) => {setPasswordLoginInfo(prevState=>({...prevState,ba_pwd:e.target.value}))}} 
                                            type='password'
                                        />
                                </Form.Item>                            
                                <Form.Item>
                                    <Button type='primary' htmlType="submit" block size="large">登录</Button>                                
                                </Form.Item>
                            </Form>
                        </div>
    //短信验证码登录
    const messageLogin = <div>
                            <Form
                                name="normal_login"
                                className="login-form"
                                initialValues={{remember: true,}}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}   
                            >
                                <Form.Item
                                    name="username"
                                    validateTrigger="onBlur"
                                    rules={[{
                                        required: true,
                                        message: '请填写手机号!',
                                    },
                                    {
                                    pattern: /^1[3-9]\d{9}$/,
                                    message: '请输入正确的手机号'
                                        }]}
                                    initialValue={prevUserPhone}                                    
                                >
                                    <Input 
                                        prefix={<MobileOutlined className="site-form-item-icon" />} 
                                        placeholder="请输入手机号" 
                                        value={adminPhone} 
                                        onChange={adminPhoneInput} 
                                        size="large"
                                    />
                                </Form.Item>
                                <Form.Item>
                                    <Row gutter={5}>
                                        <Col span={14}>
                                            <Form.Item
                                                name="captcha"
                                                validateTrigger="onBlur"    
                                                noStyle
                                                rules={[
                                                        {
                                                            required: true,
                                                            message: '请输入短信验证码!',
                                                        },
                                                        {
                                                            pattern: new RegExp('^\\d{6}$'),
                                                            message: '请输入正确的6位数字验证码!',
                                                        },
                                                    ]}
                                                >
                                                    <Input 
                                                        size="large" 
                                                        placeholder='请输入短信验证码' 
                                                        prefix={<KeyOutlined className="site-form-item-icon" />} 
                                                        value={adminCode} 
                                                        onChange={adminCodeInput} 
                                                    />
                                            </Form.Item>
                                        </Col>
                                        <Col span={10}>
                                            {isNote ? <Button disabled size="large" >{time}秒后重新发送</Button> : <Button size="large"  onClick={getCodeBtn}>获取验证码</Button>}
                                        </Col>
                                    </Row>
                                </Form.Item>                            
                                <Form.Item>
                                    <Button type='primary' htmlType="submit" block size="large">登录</Button>                                
                                </Form.Item>
                                
                            </Form>
                        </div>
    const onChange = (key) => {
        console.log(key);
      };
    const items = [
        {
            key: '1',
            label: '密码登录',
            children: <>{passwordLogin}</>,
        },
        {
            key: '2',
            label: '短信验证码登录',
            children: <>{messageLogin}</>,
        },    
    ];
    return (  
        <WebMain selectedKeys='/FirmLogin'>
            <Row style={{padding:'60px 0',backgroundColor:'#ddd'}}>
                <Col span={8}></Col>
                <Col span={8} style={{backgroundColor:'#fff',padding:'20px',borderRadius:'10px',display:'flex',alignItems:'center'}}>
                    <div style={{display:'flex',justifyContent:'center',alignItems:'center',width:'50%'}}>
                        <Space  direction='vertical' align='center'>
                            
                            <img src='/img/firm/login.svg' alt='' width={300}/>
                            
                        </Space>
                    </div>
                    <div style={{width:'50%'}}>
                        <Tabs defaultActiveKey="1" items={items} onChange={onChange} /> 
                        <a onClick={() => {navi('/FirmRegister')}}>还没有账号？请使用手机注册</a>
                    </div>
                </Col>
                <Col span={8}></Col>
            </Row>    
        </WebMain>       
    )
}

export default FirmLogin